import { render, staticRenderFns } from "./RecipientDialog.vue?vue&type=template&id=115ce56f&scoped=true"
import script from "./RecipientDialog.vue?vue&type=script&lang=js"
export * from "./RecipientDialog.vue?vue&type=script&lang=js"
import style0 from "./RecipientDialog.vue?vue&type=style&index=0&id=115ce56f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115ce56f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('115ce56f')) {
      api.createRecord('115ce56f', component.options)
    } else {
      api.reload('115ce56f', component.options)
    }
    module.hot.accept("./RecipientDialog.vue?vue&type=template&id=115ce56f&scoped=true", function () {
      api.rerender('115ce56f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/statusMonitoringAndWarning/cmp/RecipientDialog.vue"
export default component.exports